// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueNumeralFilterInstaller from 'vue-numeral-filter';

import './assets/javascript/jquery-2.1.1.min.js'
import './assets/javascript/bootstrap/js/bootstrap.min.js'
import './assets/javascript/template_js/jstree.min.js'
import './assets/javascript/template_js/template.js'
import './assets/javascript/common.js'
import './assets/javascript/global.js'
import './assets/javascript/owl-carousel/owl.carousel.min.js'

import './assets/css/bootstrap.min.css';
import './assets/javascript/font-awesome/css/font-awesome.min.css';
import './assets/css/stylesheet.css';
import './assets/css/responsive.css';
import './assets/javascript/owl-carousel/owl.carousel.css';
import './assets/javascript/owl-carousel/owl.transitions.css';

Vue.use(vueNumeralFilterInstaller);
Vue.config.productionTip = false

Vue.filter('limit', function(input, length) {
  if (input.length > length - 1) {
    return input.slice(0, length - 1) + '...';
  }
  return input;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js